import jwt from "jsonwebtoken";
import { decodedToken, tokenKey } from "../constants/constants";

export const verifyToken = (token = localStorage.getItem(tokenKey)) => {
  return jwt.verify(token, "daemoninthehouse", (err, decoded) => {
    return err ? null : decoded;
  });
};

export const generateToken = (
  token = { activeKey: decodedToken.value.activeKey || "somebody" }
) => {
  return jwt.sign(token, "daemoninthehouse", {
    expiresIn: "1h",
  });
};
